import classNames from 'classnames';
import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';

export const LidStyleRefinement = (props) => {
  const { items, refine } = useRefinementList(props);

  let filteredItems = items.filter((item) => item.label !== 'Screw-on');

  if (!filteredItems.length) {
    return null;
  }

  const handleRefine = (value) => (ev) => {
    if (ev.code && ev.code !== 'Enter') {
      return;
    }
    refine(value);
  };

  return (
    <div className="ais-RefinementList" data-type={props.attribute}>
      <header>Lid Style</header>
      <div className="ais-RefinementList-icons">
        {items.map((item) => {
          let itemClasses = classNames({
            isActive: item.isRefined,
          });
          if (item.value.includes('Flip') || item.value.includes('Screw-on')) {
            return null;
          }
          return (
            <div
              key={props.attribute + item.value}
              className={`ais-RefinementList-item ${itemClasses}`}
              onClick={(event) => refine(item.value)}
              tabIndex="0"
              onKeyDown={handleRefine(item.value)}
            >
              <figure
                className={classNames(`refine-${item.label}`, {
                  'narrow-mouth': window.location.href.includes('narrow-mouth'),
                  'wide-mouth': window.location.href.includes('wide-mouth'),
                })}
              ></figure>
              <figcaption>{item.label}</figcaption>
            </div>
          );
        })}
      </div>
    </div>
  );
};
